import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useStore } from "vuex"
import { useRoute } from 'vue-router';
import LoginDialog from '@/layout/components/loginDialog.vue'; // @ is an alias to /src
import { getConfigByCode } from "@/api/common.js"

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loginShow = ref(false)
const store = useStore();
const route = useRoute()
const state = reactive({
  loginFlag: store.state.loginFlag
})
watch(() => store.state.loginFlag, (newVal) => {
  if (newVal) {
    loginShow.value = true;
    state.loginFlag = newVal;
  }
})
watch(() => route.path, (newVal) => {
  if (newVal && newVal == 'paySuccess') {
    loginShow.value = false;
  }
})
function closeLogin() {
  loginShow.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (loginShow.value)
      ? (_openBlock(), _createBlock(LoginDialog, {
          key: 0,
          popupShow: loginShow.value,
          onClose: closeLogin
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})